module.exports = __webpack_public_path__ + "static/media/capa-emissor-1024.da7b3ea7.png";